// notifications.component.ts
import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import {
  faTimes,
  faStore,
  faThumbsUp,
  faBell,
  faBellSlash
} from '@fortawesome/free-solid-svg-icons';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent {
  @Input() notifications: any[] = [];
  @Output() close = new EventEmitter<void>();
  @Output() markAsRead = new EventEmitter<void>();

  // Iconos
  faTimes = faTimes;
  faStore = faStore;
  faThumbsUp = faThumbsUp;
  faBell = faBell;
  faBellSlash = faBellSlash;

  isMobile = window.innerWidth < 768;

  constructor(private authService: AuthService,
    private router: Router
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 768;
  }

  getNotificationTitle(notification: any): string {
    switch (notification.origin) {
      case 'new_business':
        return 'Nuevo negocio en tu zona';
      case 'like':
        return 'Nuevo "Me gusta"';
      default:
        return 'Nueva notificación';
    }
  }

  getNotificationMessage(notification: any): string {
    switch (notification.origin) {
      case 'new_business':
        return `${notification.businessName} acaba de registrarse en la plataforma. ¡Descúbrelo!`;
      case 'like':
        return `Alguien valoró tu opinión sobre ${notification.businessName}.`;
      default:
        return notification.message || 'Tienes una nueva actualización';
    }
  }

  onClose() {
    // this.markAsRead.emit();
    this.close.emit();
  }

  goToOrderDetail(notification: any) {
    if (!notification.viewed) {
      this.authService.markNotificationAsRead(notification._id).subscribe({
        next: (response) => {
          notification.viewed = true;
          window.location.href = `/user/orders/order-detail/${notification.orderId}`;
          this.onClose();
        },
        error: (error) => {
          window.location.href = `/user/orders/order-detail/${notification.orderId}`;
          this.onClose();
        }
      });
    } else {
      window.location.href = `/user/orders/order-detail/${notification.orderId}`;
      this.onClose();
    }
  }

  getStatusColor(status: string): string {
    switch (status.toLowerCase()) {
      case 'pendiente pago':
        return '#F7E3B1';
      case 'en curso':
        return '#ABC2FF';
      case 'entregado':
        return '#CCDBBC'
      default:
        return '#ECB0B7';
    }
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(value).replace(/\$\s+/g, '$');
  }
}